import { cx } from '@emotion/css';
import { useParams } from 'react-router-dom';

import { PageLoader } from 'apps/shared/scripts/components';
import { NotFoundContainer } from 'apps/shared/scripts/containers';
import { useCardById, usePostsByCardId } from 'apps/shared/scripts/graphql';
import { useIsCardDelivered, useIsOwner } from 'apps/shared/scripts/hooks';

import { CardHero, CardNavbar, CardPosts, CardTheme } from '../../components';
import CardPostModalContainer from '../CardPostModalContainer';

import { cardContainerClassName, cardOffsetClassName } from './styles';

const CardContainer = () => {
  const { cardId } = useParams();
  const { card, isLoading: isLoadingCard } = useCardById({
    variables: { id: cardId!, consumer: true },
  });
  const { posts, isLoading: isLoadingPosts } = usePostsByCardId({
    variables: { cardId: cardId! },
  });
  const { isDelivered: isCardDelivered, isLoading: isLoadingDeliveryStatus } =
    useIsCardDelivered({ id: cardId! });
  const isCardOwner = useIsOwner(card?.creator.id);

  if (isLoadingCard || isLoadingPosts || isLoadingDeliveryStatus) {
    return <PageLoader />;
  }

  if (!card) {
    return <NotFoundContainer />;
  }

  return (
    <>
      {isCardOwner && <CardNavbar />}
      <div
        className={cx(cardContainerClassName, {
          [cardOffsetClassName]: isCardOwner,
        })}
      >
        <CardTheme design={card.design}>
          <CardHero
            recipientName={card.recipientName}
            title={card.headline}
            isCardDelivered={isCardDelivered}
            senderName={card.senderName}
            numPosts={posts.length}
          />
          <CardPosts
            posts={posts}
            isCardOwner={isCardOwner}
            isCardDelivered={isCardDelivered}
          />
        </CardTheme>
      </div>
      <CardPostModalContainer />
    </>
  );
};

CardContainer.displayName = 'CardContainer';

export default CardContainer;
